import { render } from "./ScrollToTop.vue?vue&type=template&id=25a19ca8&ts=true&lang=pug"
import script from "./ScrollToTop.vue?vue&type=script&setup=true&lang=ts"
export * from "./ScrollToTop.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__